import { rgba, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const rankPreview: ThemedFunctor = ({ theme }) => css`
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
    height: 4.5rem;
    user-select: none;
    background: red;
    left: 0;
    right: 0;
    z-index: 1;
  }

  &::before {
    top: 0;
    background: linear-gradient(to bottom, ${theme.color.background.neutral.default.lowest} 0%, ${rgba(theme.color.background.neutral.default.lowest, 0)} 100%);
  }

  &::after {
    bottom: 0;
    background: linear-gradient(to top, ${theme.color.background.neutral.default.lowest} 0%, ${rgba(theme.color.background.neutral.default.lowest, 0)} 100%);
  }
`;
